import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  imports: [RouterModule]
})
export class ReportsComponent {}
